import { EmailIntegrationType } from 'enums';

export const EmailIntegrationTypeMap: Record<EmailIntegrationType, string> = {
  [EmailIntegrationType.SendOnly]: 'Send Only',
  [EmailIntegrationType.SendAndRead]: 'Send And Read',
};
